export const heroCards = [
  {
    id: 'h1',
    tag: '今晚最热',
    title: '深夜对话原声·完整版',
    desc: '从寒暄到摊牌，一段二十分钟对话完整还原现场气氛。',
    duration: '18:42',
    listens: '12.4万',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20audio%20waveform%20texture%20cover%20art%2C%20warm%20terracotta%20and%20cream%20paper%20tones%2C%20minimal%20editorial%20poster%2C%20soft%20grain%2C%20centered%20composition%2C%20no%20text&width=800&height=1000&seq=speak-hero-01&orientation=portrait',
  },
  {
    id: 'h2',
    tag: '争议对话',
    title: '关键语句逐句标注',
    desc: '把反复被引用的那几句单独拎出，前后语境一起对照着听。',
    duration: '09:15',
    listens: '8.7万',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20sound%20wave%20lines%20on%20dark%20plum%20background%2C%20golden%20accent%20highlights%2C%20minimal%20music%20poster%20art%2C%20matte%20texture%2C%20vertical%20composition%2C%20no%20text&width=800&height=1000&seq=speak-hero-02&orientation=portrait',
  },
  {
    id: 'h3',
    tag: '时间线',
    title: '事件脉络 24 小时',
    desc: '按时间顺序串起录音片段，先听起点，再听反转。',
    duration: '25:03',
    listens: '6.2万',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20circular%20ripple%20rings%20on%20muted%20sage%20green%20background%2C%20soft%20warm%20shadow%2C%20minimal%20editorial%20cover%2C%20vertical%20poster%20composition%2C%20no%20text&width=800&height=1000&seq=speak-hero-03&orientation=portrait',
  },
  {
    id: 'h4',
    tag: '新上传',
    title: '长录音节选·无人声版',
    desc: '剔除背景噪音后重新整理，重点段落做了降噪增强。',
    duration: '31:27',
    listens: '4.9万',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20layered%20paper%20cut%20sound%20waves%2C%20warm%20brick%20red%20and%20amber%20palette%2C%20minimal%20editorial%20poster%20art%2C%20flat%20composition%2C%20no%20text&width=800&height=1000&seq=speak-hero-04&orientation=portrait',
  },
];

export const hotCards = [
  {
    id: 'c1',
    tag: '对话原声',
    title: '会议室里的那通电话',
    desc: '一段被反复转述的通话录音，这次配上完整对话文字稿，边听边看更清楚。',
    duration: '14:08',
    listens: '9.6万',
    date: '今天 14:20',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20audio%20waveform%20over%20warm%20cream%20paper%20texture%2C%20terracotta%20accent%20line%2C%20minimal%20editorial%20cover%20art%2C%20soft%20grain%2C%20wide%20composition%2C%20no%20text&width=1200&height=800&seq=speak-card-01&orientation=landscape',
  },
  {
    id: 'c2',
    tag: '多人对话',
    title: '三人同框各说各话',
    desc: '同一件事三种说法，把三段陈述并排放，谁前后矛盾一听就知道。',
    duration: '22:35',
    listens: '7.3万',
    date: '今天 11:02',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20three%20overlapping%20sound%20circles%20on%20deep%20sage%20green%20background%2C%20warm%20gold%20accents%2C%20minimal%20poster%20art%2C%20matte%20texture%2C%20no%20text&width=1200&height=800&seq=speak-card-02&orientation=landscape',
  },
  {
    id: 'c3',
    tag: '现场录音',
    title: '走廊里的低声交谈',
    desc: '环境音较重但信息量不小，关键句已做时间戳标记，方便跳着听。',
    duration: '06:47',
    listens: '5.1万',
    date: '昨天 23:40',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20nocturnal%20sound%20wave%20silhouette%2C%20dark%20walnut%20brown%20and%20amber%20glow%2C%20minimal%20editorial%20cover%2C%20soft%20blur%2C%20wide%20composition%2C%20no%20text&width=1200&height=800&seq=speak-card-03&orientation=landscape',
  },
  {
    id: 'c4',
    tag: '逐句整理',
    title: '被剪掉的那十秒',
    desc: '把网络上流传版本缺失的十秒补全，前后拼接后语义明显不一样。',
    duration: '11:19',
    listens: '4.4万',
    date: '昨天 19:15',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20sound%20wave%20with%20a%20gap%20in%20the%20middle%2C%20warm%20cream%20and%20brick%20red%20palette%2C%20minimal%20flat%20poster%20art%2C%20grain%20texture%2C%20no%20text&width=1200&height=800&seq=speak-card-04&orientation=landscape',
  },
  {
    id: 'c5',
    tag: '直播回放',
    title: '连线过程中的停顿',
    desc: '保留全部停顿与语气词，听感更接近现场，也更方便判断可信度。',
    duration: '38:52',
    listens: '3.8万',
    date: '昨天 09:30',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20radio%20frequency%20lines%20on%20muted%20olive%20background%2C%20warm%20amber%20highlights%2C%20minimal%20editorial%20cover%20art%2C%20matte%20texture%2C%20no%20text&width=1200&height=800&seq=speak-card-05&orientation=landscape',
  },
  {
    id: 'c6',
    tag: '对比收听',
    title: '两个版本差在哪里',
    desc: '左右声道分别放两个版本，戴耳机听差异，比文字对比直观得多。',
    duration: '17:24',
    listens: '3.2万',
    date: '2 天前',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20split%20duotone%20sound%20waves%2C%20warm%20terracotta%20against%20deep%20teal%2C%20minimal%20editorial%20poster%2C%20soft%20grain%2C%20wide%20composition%2C%20no%20text&width=1200&height=800&seq=speak-card-06&orientation=landscape',
  },
];

export const categories = [
  { id: 'cat1', name: '对话原声', count: '386 条', icon: 'ri-chat-voice-line' },
  { id: 'cat2', name: '长录音整段', count: '142 条', icon: 'ri-mic-line' },
  { id: 'cat3', name: '短片段', count: '521 条', icon: 'ri-scissors-cut-line' },
  { id: 'cat4', name: '事件时间线', count: '64 条', icon: 'ri-time-line' },
  { id: 'cat5', name: '电话录音', count: '98 条', icon: 'ri-phone-line' },
  { id: 'cat6', name: '直播回放', count: '205 条', icon: 'ri-live-line' },
  { id: 'cat7', name: '多人对谈', count: '173 条', icon: 'ri-group-line' },
  { id: 'cat8', name: '逐句标注', count: '89 条', icon: 'ri-subtract-line' },
  { id: 'cat9', name: '降噪增强', count: '76 条', icon: 'ri-equalizer-line' },
  { id: 'cat10', name: '背景音保留', count: '58 条', icon: 'ri-volume-up-line' },
];

export const ranking = [
  { id: 'r1', name: '深夜摊牌完整对话', meta: '对话原声 · 18:42', listens: '12.4万', trend: 'up' },
  { id: 'r2', name: '会议室那通电话', meta: '电话录音 · 14:08', listens: '9.6万', trend: 'up' },
  { id: 'r3', name: '关键语句逐句标注', meta: '逐句标注 · 09:15', listens: '8.7万', trend: 'same' },
  { id: 'r4', name: '三人同框各说各话', meta: '多人对谈 · 22:35', listens: '7.3万', trend: 'up' },
  { id: 'r5', name: '事件脉络 24 小时', meta: '时间线 · 25:03', listens: '6.2万', trend: 'down' },
  { id: 'r6', name: '走廊里的低声交谈', meta: '现场录音 · 06:47', listens: '5.1万', trend: 'up' },
  { id: 'r7', name: '长录音节选无人声版', meta: '降噪增强 · 31:27', listens: '4.9万', trend: 'same' },
  { id: 'r8', name: '被剪掉的那十秒', meta: '逐句整理 · 11:19', listens: '4.4万', trend: 'down' },
];

export const stats = [
  { id: 's1', value: '2,180', unit: '条', label: '已整理录音条目', icon: 'ri-stack-line' },
  { id: 's2', value: '24', unit: '小时内', label: '热点同步更新', icon: 'ri-refresh-line' },
  { id: 's3', value: '96', unit: '%', label: '关键句人工复核', icon: 'ri-shield-check-line' },
  { id: 's4', value: '38', unit: '万', label: '累计收听人次', icon: 'ri-headphone-line' },
];

export const trustPoints = [
  {
    id: 'tp1',
    title: '保留原始语气',
    desc: '不重剪成通顺版，保留停顿、口误和语气词，听感更接近现场，也方便自行判断。',
    icon: 'ri-mic-2-line',
  },
  {
    id: 'tp2',
    title: '标注时间戳',
    desc: '每条录音都标出关键节点，几十秒一段，想跳着听还是顺序听都由你。',
    icon: 'ri-bookmark-line',
  },
  {
    id: 'tp3',
    title: '说法并排放',
    desc: '同一件事的不同说法会并排列出，谁回避了、谁改了口，对照着听更清楚。',
    icon: 'ri-layout-column-line',
  },
];

export const faqs = [
  {
    id: 'f1',
    q: '页面里的录音能直接播放吗？',
    a: '首页上的播放按钮是展示用的入口，正式收听需要进入对应条目页面。这里主要帮你快速了解有哪些语音内容、大概讲的是什么。',
  },
  {
    id: 'f2',
    q: '为什么同一件事会有好几个版本？',
    a: '录音在传播过程中常被剪辑、压缩或补录，同一段对话可能出现时长、语气都不同的版本。我们尽量把能拿到的版本并排列出，方便你对照着听。',
  },
  {
    id: 'f3',
    q: '降噪增强会不会改变原本的意思？',
    a: '降噪只处理背景噪音和电流声，不改动任何人声内容。如果某段处理痕迹明显，会在条目里额外标注，并保留一份原始未处理版本。',
  },
  {
    id: 'f4',
    q: '音质参差不齐是正常的吗？',
    a: '很多录音来自现场设备、手机或会议系统，本底噪音和回声差异很大，这是这类内容的特点。我们会尽量标注音质等级，让你选择听哪一版。',
  },
  {
    id: 'f5',
    q: '新内容多久更新一次？',
    a: '热点事件通常在 24 小时内同步整理，热点过后仍会补录时间线和缺失片段，保证页面上的内容尽量完整。',
  },
  {
    id: 'f6',
    q: '如何快速找到想听的那一段？',
    a: '可以直接用分类入口按形态筛选，也可以看收听榜单了解大家都在听什么，或者从事件时间线按顺序从头听起。',
  },
];

export const tickerItems = [
  '新增「会议室那通电话」完整版 · 14:08',
  '「被剪掉的那十秒」已补全前后语境',
  '本期时间线新增 3 个节点',
  '夜间上传批次已完成降噪增强',
];